import actions from '../utils/restActions';


const podcasts = (state = {list: [], current: {}}, action) => {

    switch (action.type) {
    case actions.podcasts.index.status.success:
	return Object.assign({}, state, {list: action.data});
    default:
	return state;
    }
}

export default podcasts;



// WEBPACK FOOTER //
// ./src/reducers/Podcasts.js